import { useEffect, useState } from "react";
import { FooterComponent } from "./Config/footer";
import { HeaderComponent } from "./Config/header";
import { HomeComponent } from "./Home/Home";
import { AttendenceComponent } from "./Attendance/Attendance";
import { LeavesComponent } from "./Leaves/Leaves";
import { LeaveSummaryComponent } from "./Leaves/LeaveSummary";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "./Config/Config";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Popover, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import Swal from "sweetalert2";

export function ProfileComponent() {
  const [punchType, setPunchType] = useState("");
  const [address, setAddress] = useState("");
  const [activeTab, setActiveTab] = useState("Home");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [leaveAccurals, setLeaveAccurals] = useState([]);
  const [storedUserData, setStoredUserData] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [profileDetails, setProfileDetails] = useState("");
  const [punchLoading, setPunchLoading] = useState(false);
  const [punchTypeLoading, setPunchTypeLoading] = useState(false);
  const percentage = 100;
  const strokeColor = punchType === "Out" ? "#007bff" : "#28a745";
  const navigate = useNavigate();

  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    const superId =
      localStorage.getItem("superId") || sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found");
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchGeolocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
          (error) => {
            console.error("Error getting geolocation:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    fetchGeolocation();

    const intervalId = setInterval(fetchGeolocation, 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleButtonClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleMouseEnter = () => {
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Home":
        return (
          <div>
            <HomeComponent></HomeComponent>
          </div>
        );
      case "Attendance":
        return (
          <div>
            <AttendenceComponent></AttendenceComponent>
          </div>
        );
      case "Leaves":
        return (
          <div>
            <LeavesComponent></LeavesComponent>
          </div>
        );
      case "LeaveSummary":
        return (
          <div>
            <LeaveSummaryComponent></LeaveSummaryComponent>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const userDataString =
      localStorage.getItem("userData") || sessionStorage.getItem("userData");
    if (userDataString) {
      try {
        const parsedUserDetails = JSON.parse(userDataString);
        setStoredUserData(parsedUserDetails);
      } catch (error) {
        console.error("Error parsing userDetails:", error);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      if (!storedUserData?.RegId) {
        return;
      }

      try {
        setPunchTypeLoading(true);
        const profileResponse = await fetch(
          `${API_BASE_URL}emp/getempprofile?regid=${storedUserData.RegId}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${tokenData}` },
          }
        );
        if (!profileResponse.ok) {
          throw new Error("Profile request failed");
        }
        const profileData = await profileResponse.json();
        setProfileDetails(profileData?.ResultData[0]);

        const punchTypeUrl = `${API_BASE_URL}attendance/getNextPunchType?regid=${storedUserData.RegId}`;
        const punchTypeResponse = await fetch(punchTypeUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        });
        if (!punchTypeResponse.ok) {
          throw new Error("PunchType request failed");
        }
        const punchTypeData = await punchTypeResponse.json();
        setPunchType(punchTypeData.ResultData.PunchType);
        setAddress(punchTypeData.ResultData.address);
      } catch (error) {
        console.error("Error in fetching data:", error.message);
      } finally {
        setPunchTypeLoading(false);
      }
    };
    fetchData();
  }, [storedUserData, location]);

  const [textNotes, setTextNotes] = useState("");
  const handleNotesChange = (e) => {
    setTextNotes(e.target.value);
  };

  const handleButtonPunchClick = async () => {
    if (!location.latitude || !location.longitude) {
      Swal.fire({
        icon: "error",
        title: "Location Required",
        text: "Please enable location services to punch in.",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      setPunchLoading(true);
      // const url = `${API_BASE_URL}pwa/writeswipe`;
      const url = `${API_BASE_URL}attendance/writeswipewithLocation`;

      const date = new Date();
      const formattedDateTime =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0") +
        " " +
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0") +
        ":" +
        String(date.getSeconds()).padStart(2, "0");

      const inPunchData = {
        superid: storedUserData.SuperId,
        cardid: profileDetails?.CardId,
        regid: storedUserData.RegId,
        dateoftransaction: formattedDateTime,
        latitude: location.latitude,
        longitude: location.longitude,
        notes: textNotes,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
        body: JSON.stringify(inPunchData),
      });

      if (!response.ok) {
        throw new Error(`POST request failed with status ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.status == true) {
        Swal.fire({
          icon: "success",
          title: "Punch Successful",
          text: "Your punch was recorded successfully!",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Punch Failed",
          text: responseData.Message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      Swal.fire({
        icon: "error",
        title: "Punch Failed",
        text:
          error.message || "An unexpected error occurred while punching in.",
        confirmButtonText: "Try Again",
      });
    } finally {
      setPunchLoading(false);
    }
  };

  const formattedTime = currentTime.toLocaleTimeString();

  const googleMapsURL = `https://www.google.com/maps?q=${location.latitude},${location.longitude}&hl=en&z=14&output=embed`;

  // useEffect(() => {
  //   if (storedUserData?.RegId) {
  //     const fetchLvAccurals = async () => {
  //       try {
  //         const lvAcuralResponse = await fetch(
  //           `${API_BASE_URL}rcservice/getleaveaccruals?regid=${storedUserData.RegId}`
  //         );
  //         const lvAcuralData = await lvAcuralResponse.json();
  //         console.log("lv,", lvAcuralData);

  //         if (lvAcuralData?.Status) {
  //           setLeaveAccurals(lvAcuralData?.ResultData[0]);
  //         } else {
  //           console.error(
  //             "Failed to fetch lv accurals:",
  //             lvAcuralResponse.statusText
  //           );
  //         }
  //       } catch (error) {
  //         console.error("Error fetching holidays:", error.message);
  //       }
  //     };

  //     fetchLvAccurals();
  //   }
  // }, [storedUserData?.RegId]);
  // console.log(storedUserData, "user data");

  return (
    <div>
      {punchLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <HeaderComponent></HeaderComponent>
      <div
        className="app-main flex-column flex-row-fluid mb-4"
        id="kt_app_main"
      >
        <div className="d-flex flex-column flex-column-fluid">
          <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div
              id="kt_app_toolbar_container"
              className="app-container container-xxl d-flex justify-content-between"
            >
              <div className="d-flex">
                <p className="page-heading text-dark  fs-3  my-0 fw-light me-3">
                  Welcome {"  "}
                </p>
                <p className="page-heading text-dark  fs-3  my-0 fw-bold">
                  {storedUserData.UserName}!
                </p>
              </div>
              {storedUserData.IsManager && (
                <div
                // className="d-flex justify-content-center align-items-center p-0"
                // onMouseLeave={handleMouseLeave}
                >
                  {/* <div
                    // className="position-relative"
                    // onMouseEnter={handleMouseEnter}
                  > */}
                  {/* <button
                      className="btn btn-sm btn-primary"
                      onClick={handleButtonClick}
                      style={{
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      My Team
                    </button>
                    {isDropdownOpen && (
                      <div
                        className="menu menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold dropdown-menu show"
                        id="dropdownMenu"
                      >
                        <div className="menu-item px-3">
                          <Link
                            to="/MonthlyAttendance"
                            className="menu-link px-3"
                          >
                            Monthly Attendance
                          </Link>
                        </div>

                        <>
                          <div className="menu-item px-3">
                            <Link
                              to="/BulkAttendance"
                              className="menu-link px-3"
                            >
                              Bulk Attendance
                            </Link>
                          </div>
                          <div className="menu-item px-3">
                            <Link
                              to="/ManualAttendance"
                              className="menu-link px-3"
                            >
                              Manual Attendance
                            </Link>
                          </div>
                          <div className="menu-item px-3">
                            <Link to="/TeamMembers" className="menu-link px-3">
                              Team Members
                            </Link>
                          </div>

                          <div className="menu-item px-3">
                            <Link
                              to="/LeaveApplication"
                              className="menu-link px-3"
                            >
                              Leave Application
                            </Link>
                          </div>
                        </>
                      </div>
                    )} */}
                  {/* <Popover
                    placement="bottomLeft"
                    content={
                      <div
                      // className="menu menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold dropdown-menu show"
                      >
                        <div className="menu-item">
                          <Link to="/MonthlyAttendance" className="menu-link">
                            Monthly Attendance
                          </Link>
                        </div>

                        <>
                          <div className="menu-item">
                            <Link to="/BulkAttendance" className="menu-link">
                              Bulk Attendance
                            </Link>
                          </div>
                          <div className="menu-item">
                            <Link to="/ManualAttendance" className="menu-link">
                              Manual Attendance
                            </Link>
                          </div>
                          <div className="menu-item">
                            <Link to="/TeamMembers" className="menu-link">
                              Team Members
                            </Link>
                          </div>

                          <div className="menu-item">
                            <Link to="/LeaveApplication" className="menu-link">
                              Leave Application
                            </Link>
                          </div>
                        </>
                      </div>
                    }
                  >
                    <div className="bg-primary rounded text-white p-2">
                      <i className="fa-solid fa-people-group fa-xl text-white"></i>{" "}
                      My Team
                    </div>
                  </Popover> */}
                  {/* </div> */}
                </div>
              )}
            </div>
          </div>
          <div id="kt_app_content" className=" flex-column-fluid mb-4	">
            <div
              id="kt_app_content_container"
              className="app-container container-xxl"
            >
              <div className="card mb-2 mb-xl-10">
                <div className="card-body p-1">
                  <div className="d-flex flex-wrap mb-3 ">
                    <div className="mb-5 row w-100">
                      <div className="col-5">
                        <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                          <img src="assets/images/person.jpg" alt="image" />
                          <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px"></div>
                        </div>
                      </div>
                      <div className="col-7 row">
                        <div className="d-flex flex-column col-12 mt-4">
                          {/* <div className="d-flex align-items-center w-100 mb-2">
                            <p className="text-gray-900  text-hover-primary fs-2 fw-bold me-1">
                              {storedUserData.UserName}
                            </p>
                            <a>
                              <span className="svg-icon svg-icon-1 svg-icon-primary">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                            </a>
                          </div> */}
                          <div className="d-flex flex-wrap fw-semibold fs-6 mb-4  m-0 row justify-content-between">
                            <div className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2 col-4">
                              <span className="svg-icon svg-icon-4 d-flex">
                                <i className="fa-solid fa-id-badge fs-1 me-2"></i>
                                <h6 className="text-gray-400">
                                  {profileDetails?.Designation
                                    ? profileDetails?.Designation
                                    : "N/A"}
                                </h6>
                              </span>
                            </div>
                            <div className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2 col-4">
                              <span className="svg-icon svg-icon-4 d-flex">
                                <i className="fa-regular fa-address-card fs-1 me-2"></i>
                                <h6 className="text-gray-400">
                                  {storedUserData?.RegId}
                                </h6>
                              </span>
                            </div>
                            <div className="d-flex align-items-center text-gray-400 text-hover-primary mb-2 col-4">
                              <span className="svg-icon svg-icon-4 d-flex">
                                {/* <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                                    fill="currentColor"
                                  />
                                </svg> */}
                                <i className="fa-solid fa-phone fs-1 me-2"></i>
                                <h6 className="text-gray-400">
                                  {profileDetails?.Mobile}
                                </h6>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="row justify-content-between m-2">
                        {/* <div className="row col-8 d-flex justify-content-evenly">
                            <div className="col-12 fw-bold fs-7">Leaves</div>
                            <div
                              className="border border-gray-300 rounded col-5 mb-2"
                              style={{ backgroundColor: "#FFE5D9" }}
                            >
                              <div className="row">
                                <div className="col-4 p-2 text-start">
                                  <i
                                    className="fa-solid fa-person-walking-arrow-right fa-2xl"
                                    style={{ color: "#E2715E" }}
                                  ></i>
                                </div>
                                <div
                                  className="fs-4 fw-bold col-8 text-start pt-1"
                                  data-kt-countup="true"
                                >
                                  {leaveAccurals.Accrued
                                    ? leaveAccurals.Accrued
                                    : "N/A"}
                                </div>
                                <div
                                  className="fw-semibold fs-6  col-12 text-center p-0"
                                  style={{ color: "#E2715E" }}
                                >
                                  Total leaves
                                </div>
                              </div>
                            </div>
                            <div
                              className="border border-gray-300 rounded col-5 mb-2"
                              style={{ backgroundColor: "#D4F5E9" }}
                            >
                              <div className="row">
                                <div className="col-4 p-2 text-start">
                                  <i
                                    className="fa-solid fa-calendar-plus fa-2xl"
                                    style={{ color: "#37A383" }}
                                  ></i>
                                </div>
                                <div
                                  className="fs-3 fw-bold col-8 text-start pt-1"
                                  data-kt-countup="true"
                                >
                                  {leaveAccurals.Balance
                                    ? leaveAccurals.Balance
                                    : "N/A"}
                                </div>
                                <div
                                  className="fw-semibold fs-6  col-12 text-center p-0"
                                  style={{ color: "#37A383" }}
                                >
                                  Available
                                </div>
                              </div>
                            </div>
                            <div
                              className="border border-gray-300 rounded col-5 mb-2"
                              style={{ backgroundColor: "#E8EAF6" }}
                            >
                              <div className="row">
                                <div className="col-4 p-2 text-start">
                                  <i
                                    className="fa-solid fa-calendar-minus fa-2xl"
                                    style={{ color: "#5C6BC0" }}
                                  ></i>
                                </div>
                                <div
                                  className="fs-3 fw-bold col-8 text-start pt-1"
                                  data-kt-countup="true"
                                >
                                  {leaveAccurals.Taken
                                    ? leaveAccurals.Taken
                                    : "NA"}
                                </div>
                                <div
                                  className="fw-semibold fs-6  col-12 text-center p-0"
                                  style={{ color: "#5C6BC0" }}
                                >
                                  Used leaves
                                </div>
                              </div>
                            </div>
                            <div
                              className="border border-gray-300 rounded col-5 mb-2"
                              style={{ backgroundColor: "#F3E5F5" }}
                            >
                              <div className="row">
                                <div className="col-4 p-2 text-start">
                                  <i
                                    className="fa-solid fa-hand-point-right fa-2xl"
                                    style={{ color: "#8E24AA" }}
                                  ></i>
                                 
                                </div>
                                <div
                                  className="fs-3 fw-bold col-8 text-start pt-1"
                                  data-kt-countup="true"
                                >
                                  {leaveAccurals.CarryForwardLeaves
                                    ? leaveAccurals.CarryForwardLeaves
                                    : "NA"}
                                </div>
                                <div
                                  className="fw-semibold fs-6  col-12 text-center p-0"
                                  style={{ color: "#8E24AA" }}
                                >
                                  Carry forward
                                </div>
                              </div>
                            </div>
                          </div> */}
                        <div className="row col-8 d-flex ">
                          <div className="d-flex align-items-center justify-content-between">
                            <p className="text-gray-600 text-semibold m-0">
                              Notes
                            </p>
                            <Link to="/maps">
                              <i className="fa-solid fa-location-dot fs-2x"></i>
                            </Link>
                          </div>
                          <TextArea
                            rows={3}
                            placeholder="Notes"
                            value={textNotes} // Bind the state
                            onChange={handleNotesChange} // Update state on change
                          />
                        </div>
                        {punchTypeLoading ? (
                          <div
                            className="col-3 d-flex align-items-center "
                            style={{
                              width: "auto",
                            }}
                          >
                            <Spin />
                          </div>
                        ) : (
                          <div
                            onClick={handleButtonPunchClick}
                            className="col-3 d-flex align-items-center "
                            style={{
                              position: "relative",
                              width: "35%",
                              aspectRatio: "1 / 1",
                            }}
                          >
                            {/* Circular Progress Bar */}
                            <CircularProgressbar
                              value={percentage}
                              strokeWidth={5}
                              styles={{
                                path: { stroke: strokeColor }, // Set stroke color dynamically
                                trail: { stroke: "#d6d6d6" }, // Trail color
                              }}
                            />

                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <svg
                                fill={strokeColor}
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#ffffff"
                              >
                                <path d="M390.42,75.28a10.45,10.45,0,0,1-5.32-1.44C340.72,50.08,302.35,40,256.35,40c-45.77,0-89.23,11.28-128.76,33.84C122,77,115.11,74.8,111.87,69a12.4,12.4,0,0,1,4.63-16.32A281.81,281.81,0,0,1,256.35,16c49.23,0,92.23,11.28,139.39,36.48a12,12,0,0,1,4.85,16.08A11.3,11.3,0,0,1,390.42,75.28Zm-330.79,126a11.73,11.73,0,0,1-6.7-2.16,12.26,12.26,0,0,1-2.78-16.8c22.89-33.6,52-60,86.69-78.48C209.42,65,302.35,64.72,375.16,103.6c34.68,18.48,63.8,44.64,86.69,78a12.29,12.29,0,0,1-2.78,16.8,11.26,11.26,0,0,1-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56-66.34-35.28-151.18-35.28-217.29.24-31.44,16.8-57.79,40.8-78.59,71A10,10,0,0,1,59.63,201.28ZM204.1,491a10.66,10.66,0,0,1-8.09-3.6C175.9,466.48,165,453,149.55,424c-16-29.52-24.27-65.52-24.27-104.16,0-71.28,58.71-129.36,130.84-129.36S387,248.56,387,319.84a11.56,11.56,0,1,1-23.11,0c0-58.08-48.32-105.36-107.72-105.36S148.4,261.76,148.4,319.84c0,34.56,7.39,66.48,21.49,92.4,14.8,27.6,25,39.36,42.77,58.08a12.67,12.67,0,0,1,0,17A12.44,12.44,0,0,1,204.1,491Zm165.75-44.4c-27.51,0-51.78-7.2-71.66-21.36a129.1,129.1,0,0,1-55-105.36,11.57,11.57,0,1,1,23.12,0,104.28,104.28,0,0,0,44.84,85.44c16.41,11.52,35.6,17,58.72,17a147.41,147.41,0,0,0,24-2.4c6.24-1.2,12.25,3.12,13.4,9.84a11.92,11.92,0,0,1-9.47,13.92A152.28,152.28,0,0,1,369.85,446.56ZM323.38,496a13,13,0,0,1-3-.48c-36.76-10.56-60.8-24.72-86-50.4-32.37-33.36-50.16-77.76-50.16-125.28,0-38.88,31.9-70.56,71.19-70.56s71.2,31.68,71.2,70.56c0,25.68,21.5,46.56,48.08,46.56s48.08-20.88,48.08-46.56c0-90.48-75.13-163.92-167.59-163.92-65.65,0-125.75,37.92-152.79,96.72-9,19.44-13.64,42.24-13.64,67.2,0,18.72,1.61,48.24,15.48,86.64,2.32,6.24-.69,13.2-6.7,15.36a11.34,11.34,0,0,1-14.79-7,276.39,276.39,0,0,1-16.88-95c0-28.8,5.32-55,15.72-77.76,30.75-67,98.94-110.4,173.6-110.4,105.18,0,190.71,84.24,190.71,187.92,0,38.88-31.9,70.56-71.2,70.56s-71.2-31.68-71.2-70.56C303.5,293.92,282,273,255.42,273s-48.08,20.88-48.08,46.56c0,41,15.26,79.44,43.23,108.24,22,22.56,43,35,75.59,44.4,6.24,1.68,9.71,8.4,8.09,14.64A11.39,11.39,0,0,1,323.38,496Z" />
                              </svg>

                              {/* Text */}
                              <div className="row text-center mt-2">
                                <div className="fw-bold">
                                  {punchType === "In"
                                    ? "Punch In"
                                    : "Punch Out"}
                                </div>
                                <div className="text-gray-600">
                                  {formattedTime}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-3">{renderContent()}</div>
      </div>
      <FooterComponent></FooterComponent>
    </div>
  );
}
